import React, { useState, useRef, useEffect } from "react";
import Barcode from "react-barcode";
import { toPng } from "html-to-image";
import jsPDF from "jspdf";
import "./barcode reader.css";

function BarcodeGenerator() {
  const [barcodeValue, setBarcodeValue] = useState("");
  const [productCode, setProductCode] = useState("");
  const [price, setPrice] = useState("");
  const barcodeRef = useRef(null);
  const [barcodeWidth, setBarcodeWidth] = useState(3);

  useEffect(() => {
    if (barcodeValue) {
      const length = barcodeValue.length;
      let newWidth;
      
      if (length <= 8) {
        newWidth = 4;
      } else if (length <= 12) {
        newWidth = 3.2;
      } else if (length <= 16) {
        newWidth = 2.6;
      } else {
        newWidth = 2.0;
      }
      
      setBarcodeWidth(newWidth);
    }
  }, [barcodeValue]);





  const handleDownload = async () => {
    if (!barcodeRef.current) return;

    try {
      const container = barcodeRef.current;
      
      const dataUrl = await toPng(container, {
        backgroundColor: '#FFFFFF',
        pixelRatio: 3,
        quality: 1
      });

      const pdf = new jsPDF({
        unit: 'mm',
        format: [63, 22],
        orientation: 'landscape'
      });

      pdf.setFillColor(255, 255, 255);
      pdf.rect(0, 0, 63, 22, 'F');

      pdf.addImage(
        dataUrl,
        'PNG',
        63 - 28,
        0,
        28,
        22
      );

      pdf.save(`${barcodeValue || "barcode"}.pdf`);

    } catch (err) {
      console.error("Error generating PDF:", err);
      alert("Error generating PDF. Please try again.");
    }
  };






  
  return (
    <div className="barcode-app">
      <div className="input-section">
        <h1 className="app-title">Professional Barcode Generator</h1>

        <div className="input-group">
          <label htmlFor="barcode">Barcode Value *</label>
          <input
            id="barcode"
            type="text"
            value={barcodeValue}
            onChange={(e) => setBarcodeValue(e.target.value)}
            placeholder="Enter barcode value (e.g., C04818001)"
            maxLength={20}
          />
        </div>

        <div className="input-group">
          <label htmlFor="productCode">Product Code/Name</label>
          <input
            id="productCode"
            type="text"
            value={productCode}
            onChange={(e) => setProductCode(e.target.value)}
            placeholder="Product code (e.g., CHP-623 53 17 C36)"
          />
        </div>

        <div className="input-group">
          <label htmlFor="price">Price</label>
          <input
            id="price"
            type="text"
            value={price}
            onChange={(e) => setPrice(e.target.value)}
            placeholder="Price (e.g., 9500/-)"
          />
        </div>
      </div>

      <div className="barcode-display">
        <div 
          className="barcode-container" 
          ref={barcodeRef}
          style={{
            width: '28mm',
            height: '22mm',
            display: 'flex',
            flexDirection: 'column',
            backgroundColor: 'white',
            padding: '0',
            boxSizing: 'border-box',
            position: 'relative',
            border: '1px dashed #ccc',
            overflow: 'hidden',
            flexShrink: 0
          }}
        >
          {barcodeValue ? (
            <>
              {/* TOP: Barcode - FILL 11mm - WITH 2mm GAPS ON LEFT & RIGHT */}
              <div style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                height: '50%',
                width: '100%',
                padding: '0 2mm', // ← 2mm gap on left and right
                boxSizing: 'border-box',
                flexShrink: 0,
                overflow: 'hidden',
                backgroundColor: 'white'
              }}>
                <div style={{
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  width: '100%',
                  height: '100%'
                }}>
                  <Barcode
                    value={barcodeValue}
                    format="CODE128"
                    width={barcodeWidth}
                    height={300}
                    displayValue={false}
                    background="white"
                    margin={0}
                    fontSize={0}
                    lineColor="#000000"
                  />
                </div>
              </div>

              {/* BOTTOM: Details - 11mm - WITH 2mm GAPS ON LEFT & RIGHT */}
              <div style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                height: '50%',
                width: '100%',
                padding: '0 2mm', // ← 2mm gap on left and right
                boxSizing: 'border-box',
                borderTop: '0.5px solid #000',
                flexShrink: 0,
                overflow: 'hidden',
                backgroundColor: 'white'
              }}>
                <p style={{ 
                  margin: '0 0 1px 0',
                  fontSize: '12pt',
                  fontWeight: 'bold',
                  textAlign: 'center',
                  color: '#000',
                  lineHeight: '1.2',
                  width: '100%',
                  whiteSpace: 'nowrap',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis'
                }}>
                  {productCode || barcodeValue}
                </p>

                {price && (
                  <p style={{ 
                    margin: '0',
                    fontSize: '18pt',
                    fontWeight: 'bold',
                    textAlign: 'center',
                    color: '#000',
                    width: '100%',
                    whiteSpace: 'nowrap',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis'
                  }}>
                    {price}
                  </p>
                )}
              </div>
            </>
          ) : (
            <div style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              height: '100%',
              width: '100%',
              backgroundColor: 'white'
            }}>
              <p style={{ fontSize: '10pt', color: '#999', textAlign: 'center' }}>
                Enter values<br/>to generate barcode
              </p>
            </div>
          )}
        </div>

        <button
          className="download-btn"
          onClick={handleDownload}
          disabled={!barcodeValue}
        >
          <svg
            width="18"
            height="18"
            viewBox="0 0 24 24"
            fill="none"
          >
            <path
              d="M12 15V3M12 15L8 11M12 15L16 11M21 15V19C21 20.1046 20.1046 21 19 21H5C3.89543 21 3 20.1046 3 19V15"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
          Download PDF
        </button>
      </div>
    </div>
  );
}

export default BarcodeGenerator;